import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from "moment";



class MmyyDateCellRender extends Component {

  render() {
    return this.props.value != null ? moment(this.props.value).format('MM/YYYY') : <></>;
  }
}

MmyyDateCellRender.propTypes = {
  value: PropTypes.any,
};

export default MmyyDateCellRender;